import React, {useEffect, useRef, useState} from "react";

export default function CompleteStep({animating, chosenLocation, successful, handleStarOver}) {

    const timer = useRef(null);
    const [timeLeft, setTimeLeft] = useState(20);

    useEffect(() => {
        if (successful && timeLeft > 0) {
            timer.current = setTimeout(() => {
                setTimeLeft(timeLeft - 1)
            }, 1000)
        } else if (successful && timeLeft === 0) {
            window.location.href = chosenLocation?.site
        }

        return () => {
            if (timer.current) {
                clearTimeout(timer.current);
            }
        }

    }, [successful, timeLeft]);


    return (
        <div className={"container mx-auto px-4 lg:px-8"}>
            <div className={"grid grid-cols-1 lg:grid-cols-12 gap-x-8 gap-y-6"}>
                <div className={"lg:col-span-8 lg:col-start-3"}>
                    {successful ? (
                        <>
                            {chosenLocation?.confirmation?.heading ? (
                                <h2>{chosenLocation.confirmation.heading}</h2>
                            ) : (
                                <h2>Thank you for your request!</h2>
                            )}

                            {chosenLocation?.confirmation?.message ? (
                                <div className={'large-p mb-6'} dangerouslySetInnerHTML={{__html: chosenLocation.confirmation.message}}></div>
                            ) : (
                                <>
                                    <p className={"large-p"}>
                                        Our local Dumpster Consultant will follow up with your request immediately.
                                    </p>
                                    <p className={"large-p"}>
                                        We appreciate your trust in our service and look forward to making your cleanup quick and easy!
                                    </p>
                                </>
                            )}


                            {chosenLocation && (
                                <>
                                    <p>
                                        Please give us a call at <a href={`tel:${chosenLocation.phone}`} className={"font-bold !decoration-current hover:!decoration-transparent"}>{chosenLocation.phone}</a> if you have any questions.
                                    </p>
                                    <p>
                                        You will be automatically redirected to
                                        the <strong>{chosenLocation.location_name}</strong> page
                                        in <strong>{timeLeft}</strong> seconds.
                                    </p>
                                </>
                            )}
                        </>
                    ) : (
                        <>
                            <h2>
                                Oops! Something went wrong.
                            </h2>
                            <p className={'large-p'}>
                                It looks like your request didn't submit due to a technical issue. Please try again.
                            </p>
                            <button className={"btn"} onClick={handleStarOver}>Try again</button>
                            <p className={"large-p"}>
                                If the problem persists, call us
                                at <a href={`tel:${chosenLocation?.phone}`} className={"whitespace-nowrap font-bold"}>{chosenLocation?.phone}</a> for
                                help.
                            </p>
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}